<!--
 * @Author: xiaokun
 * @Date: 2020-04-10 16:19:37
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-10 17:51:58
 * @Description: 课程表格 操作组件
 -->
<template>
  <div class="list-table-custom-action">
    <div
      v-for="(action,index) in actionMap"
      :key="index"
      class="action-item"
    >
      <template v-if="action.componentsName==='button'">
        <!-- 普通文本按钮 -->
        <mk-button
          v-bind="action.componentsConfig"
          :type="action.componentsConfig.type||'text'"
          @click="handleOnEmit(action)"
        >
          {{ handelText(action) }}
        </mk-button>
      </template>
      <template v-else-if="action.componentsName==='popover'">
        <mk-popover
          v-model="showPopoverMap[index]"
          placement="top"
          trigger="click"
          popper-class="action-popover-custom-class"
          reference
          @show="handelOnPopoverShow(index)"
        >
          <div>
            <div class="mention-text">
              <mk-iconfont icon-class="guanbihuojingshihuocuowu" />
              {{ handelTip(action) }}
            </div>
            <div class="button-delete-button">
              <mk-button-biz
                width="50px"
                height="24px"
                @click="handleOnEnterClick(action,index)"
              >
                确定
              </mk-button-biz>
              <mk-button-biz
                width="50px"
                height="24px"
                type="primary"
                @click="handleOnCancelClick(action,index)"
              >
                取消
              </mk-button-biz>
            </div>
          </div>
          <mk-button
            slot="reference"
            type="text"
            class="list-table-action__remove"
          >
            {{ handelText(action) }}
          </mk-button>
        </mk-popover>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListTableCustomAction',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      showPopoverMap: []
    }
  },
  computed: {
    actionMap () {
      return this.item.actionMap || []
    }
  },
  mounted () {
    this.showPopoverMap = new Array(this.item.actionMap.length).fill(false)
  },
  methods: {
    // 向上传递事件：统一调用该方法向上传递
    handleOnEmit (action, otherParams = {}) {
      this.$emit(action.eventName, {
        row: this.scope.row,
        ...otherParams
      })
    },

    // 通过textByOtherKey去获取当前对应的值
    getTextByOtherKeyValue (textByOtherKey) {
      let keyValue = ''
      if (textByOtherKey) {
        keyValue = this.scope.row[textByOtherKey]
      }

      return keyValue
    },

    // 处理操作对应的文字
    handelText (action) {
      let text = action.text

      const keyValue = this.getTextByOtherKeyValue(action.textByOtherKey)

      if (keyValue) {
        text = action.text[keyValue]
      }

      return text
    },

    // 处理popover对应的提示
    handelTip (action) {
      let tip = action.otherConfig.tip

      const keyValue = this.getTextByOtherKeyValue(action.textByOtherKey)

      if (keyValue) {
        tip = action.otherConfig.tip[keyValue]
      }

      return tip || '是否执行该操作？'
    },

    handelOnPopoverShow (index) {
      this.$set(this.showPopoverMap, index, true)
    },

    // popover对应的确认事件
    handleOnEnterClick (action, index) {
      this.showPopoverMap[index] = false

      this.handleOnEmit(action)
    },

    // popover对应的取消事件
    handleOnCancelClick (action, index) {
      this.$set(this.showPopoverMap, index, false)
      // this.handleOnEmit(action)
    }
  }
}
</script>

<style lang="scss" scoped>
// 删除浮层
.action-popover-custom-class {
  .mention-text {
    font-size: 14px;
    color: #595959;

    .icon-mk-guanbihuojingshihuocuowu {
      font-size: 14px;
      color: #f5222d;
      margin-right: 8px;
    }
  }

  .button-delete-button {
    margin-top: 12px;
    text-align: right;
  }
}

.list-table-custom-action {
  display: flex;

  .action-item {
    margin-right: 15px;

    .el-button {
      font-size: 13px;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

</style>
